import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Modal, Select, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ObtenerPrioridades } from '../../helpers/AsuntosHelper';
import { GuardarCapitulo } from '../../helpers/CapitulosHelper';
import { GuardarDepartamento } from '../../helpers/DepartamentosHelper';
import { ObtenerDirecciones } from '../../helpers/DireccionesHelper';
import { GuardarPrioridad } from '../../helpers/PrioridadesHelper';
import { GuardarNuevoTipoServicio } from '../../helpers/ServiciosHelper';
import { CapitulosContext } from '../../pages/catalogos/CapitulosPage';
import { DepartamentosContext } from '../../pages/catalogos/DepartamentosPage';
import { PrioridadesContext } from '../../pages/catalogos/PrioridadesPage';
import { TiposServicioContext } from '../../pages/catalogos/ServiciosTipoPage';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
export const ModalAgregaDepartamentoComponent = () => {
    const {modalAgregaDepartamento, setModalAgregaDepartamento, obtenerDepartamentos, departamentoSel, departamentos} = useContext(DepartamentosContext);
    const [descripcion, setDescripcion] = useState();
    const [errorGuardado, setErrorGuardado] = useState(false);
    const [idDepartamento, setIdDepartamento] = useState(0);
    const [idDireccion, setIdDireccion] = useState();
    const [idDepartamentoPadre, setIdDepartamentoPadre] = useState(0);
    const refForm = useRef();
    const refDire = useRef();
    const [direcciones, setDirecciones] = useState([]);
    console.log('Valor de modal agrega', modalAgregaDepartamento);


    const verificaAccion = () => {
      console.log('Capitulo en modal', departamentoSel)
    if(departamentoSel?.idDepartamento) {
        console.log('Esta editando', departamentoSel);
        setIdDepartamento(departamentoSel.idDepartamento);
        setIdDireccion(departamentoSel.idDireccion)
        setDescripcion(departamentoSel.descripcion);
        setIdDepartamentoPadre(departamentoSel.idDepartamentoPadre);
        //refDire.current.innetText = departamentoSel
      } else {
        console.log('esta agregando', departamentoSel);
        setDescripcion('');
        setIdDireccion(-1);
        setIdDepartamento(0);
        setIdDepartamentoPadre(0);
      }
    }

    useEffect(() => {
      verificaAccion();
    }, [departamentoSel])
    

    const handleClose = () => {
        setModalAgregaDepartamento(false);
    }

    const handleSubmit =  (event) => {
        event.preventDefault();
       // refForm.current.isValidate();
        GuardarDepartamento(descripcion, idDireccion, idDepartamento, idDepartamentoPadre).then(respuesta => {
            console.log('respuesta de guardado en modal', respuesta);
            if(respuesta!=1) {
                setErrorGuardado(true);
            } else{
                setErrorGuardado(false);
                obtenerDepartamentos();
                handleClose();

            }
        })
    }
    const obtenerDirecciones = async() => {
      const respuesta = await ObtenerDirecciones().then(datos=>{console.log('direcciones obtenidas para modal agregar departamento',datos);setDirecciones(datos)});
      console.log('datos obtenidos',respuesta);
    }

    

    useEffect(() => {
      obtenerDirecciones()
    }, [])
    


  return (
      <div
        style={{
            minWidth:600
        }}
    >
     <Dialog open={modalAgregaDepartamento} onClose={handleClose}>
        <form onSubmit={handleSubmit} ref={refForm}>
        <DialogTitle>Departamento</DialogTitle>
        <DialogContent
            style={{minWidth:600}}
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            name="txtTipoServicio"
            label="Descripción"
            type="text"
            fullWidth
            variant="standard"
            required={true}
            onChange={(e) => setDescripcion(e.target.value)}
            value={descripcion}
          />
       <FormControl variant='standard' fullWidth>
        <InputLabel id="demo-simple-select-label">Dirección</InputLabel>
        <Select
          ref={refDire}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={idDireccion}
          label="Dirección"
          InputLabelProps={{ shrink: true }}
          onChange={(event) => {console.log(refDire);setIdDireccion(event.target.value)}}
          //onSelect={(event => handleChange(event))}
        >
          {
            direcciones?.map(direccion1 => (
              <MenuItem key={direccion1.idDireccion} value={direccion1.idDireccion}>{direccion1.direccion}</MenuItem>
            ))
          }
        </Select>
      </FormControl>      
      <FormControl variant='standard' fullWidth>
        <InputLabel id="cboDepartamentoPadre-label">Departamento superior</InputLabel>
        <Select
          labelId="cboDepartamentoPadre"
          id="cboDepartamentoPadre"
          value={idDepartamentoPadre || -1}
          label="Departamento superior"
          onChange={(event) => {console.log(event);setIdDepartamentoPadre(event.target.value)}}
          //onSelect={(event => handleChange(event))}
        >
          {
            departamentos?.map(departamento => (
              <MenuItem key={departamento.idDepartamento} value={departamento.idDepartamento}>{departamento.descripcion}</MenuItem>
            ))
          }
        </Select>
      </FormControl>          
           {
            errorGuardado && (
              <Typography
                style={{
                    fontSize:12,
                    color:'red'
                }}
              >
                Error al guardar
            </Typography>
            )
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type='submit' >Guardar</Button>
        </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
